import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { GlobalStyles } from './styles/GlobalStyles';
import apiPerformanceMonitor from './utils/apiPerformanceMonitor';
import firestoreMonitor from './utils/firestoreMonitor';

// Set up React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

// Always initialize API Performance Monitor (it's lightweight and useful)
// It intercepts fetch calls and tracks Firestore operations from response headers
window.apiMonitor = apiPerformanceMonitor;
if (process.env.NODE_ENV === 'development' || window.location.search.includes('debug=api')) {
  console.log('🔍 API Performance Monitor enabled. Monitoring all API calls...');
}

// Always initialize Firestore monitor (it will enable itself based on conditions)
window.firestoreMonitor = firestoreMonitor;

// Always enable Firestore monitor - it tracks operations from API response headers
// The backend middleware adds Firestore operation counts to response headers
firestoreMonitor.enabled = true;
console.log('🔥 Firestore Monitor enabled. Tracking Firestore operations...');
console.log('💡 Reports will appear in console 5 seconds after page load');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <GlobalStyles />
      <App />
    </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
